exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".camera_outer[data-v-733df2e5]{position:relative;overflow:hidden;background-size:100%}.camera_outer .tx_img[data-v-733df2e5],.camera_outer canvas[data-v-733df2e5],.camera_outer video[data-v-733df2e5]{-moz-transform:scaleX(-1);-webkit-transform:scaleX(-1);-o-transform:scaleX(-1);transform:scaleX(-1)}.camera_outer img[data-v-733df2e5]{width:100px}.video-frame[data-v-733df2e5]{object-fit:fill}", ""]);

// exports
